const workflowLaunchEnumerators = {
  status: [
    'draft',
    'scheduled',
    'inProgress',
    'completed',
    'archived',
  ],
  type: ['workOrder'],
};

export default workflowLaunchEnumerators;
